import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchOrderDetails,
  triggerResendEmail,
  viewCCDetails,
} from "../../services/services";

// Initial State
const initialState = {
  orderDetails: null,
  creditCardDetails: null,
  emailSend: null,
  limit: null,
  isLoading: true,
  isError: false,
  errorMessage: "",
};

// Async Thunk for fetching order details
export const fetchOrderDetailsAsync = createAsyncThunk(
  "orderDetails/fetchCustomerAgentDetails",
  async (orderId) => {
    const response = await fetchOrderDetails(orderId);
    return response;
  }
);

// Async Thunk for fetching CC details
export const fetchCCDetails = createAsyncThunk(
  "orderDetails/fetchCCDetails",
  async (orderId) => {
    const response = await viewCCDetails(orderId);
    return response;
  }
);

// Async Thunk for fetching CC details
export const resendEmail = createAsyncThunk(
  "orderDetails/resendEmail",
  async ({ orderId }) => {
    const response = await triggerResendEmail(orderId);
    return response;
  }
);

// Order Details Slice
const customerAgentDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    clearCreditCardDetails: (state) => {
      state.creditCardDetails = null;
    },
    clearLimit: (state) => {
      state.limit = null;
    },
    clearCustomerData: (state) => {
      state.orderDetails = null;
      state.emailSend = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderDetailsAsync.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchOrderDetailsAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderDetails = action.payload;
      })
      .addCase(fetchOrderDetailsAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      })
      .addCase(fetchCCDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCCDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.creditCardDetails = action.payload;
        state.limit = {
          retrieval_count: action.payload.retrieval_count,
          max_retrieval_count: action.payload.max_retrieval_count,
        };
      })
      .addCase(fetchCCDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      })
      .addCase(resendEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.emailSend = action.payload;
      })
      .addCase(resendEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      });
  },
});

export const { clearCreditCardDetails, clearLimit, clearCustomerData } =
  customerAgentDetailsSlice.actions;

// Export reducer and actions
export default customerAgentDetailsSlice.reducer;
